import { END_POINTS } from '@config';
import ApiTags from '@constants/api-tags';
import { api } from '@core/baseApi';
import { HTTPResponse, OrgAndBranchId } from '@types';
import { buildQueryString } from '@utils/queryStringBuilder';

import {
  BranchTag,
  CreateMemberTagRequest,
  GetMemberTagsResponse,
  UpdateMemberTagRequest
} from './MemberQueryTypes';

const extendedBaseQuery = api.injectEndpoints({
  endpoints: (builder) => ({
    getBranchTags: builder.query<BranchTag[], OrgAndBranchId>({
      query: (params) => ({
        url: END_POINTS.MEMBER_TAG.GET_TAGS(params),
        method: 'GET'
      }),
      transformResponse: (response: BranchTag[] | GetMemberTagsResponse) =>
        Array.isArray(response) ? response : response.tags,
      providesTags: [ApiTags.BRANCH_TAGS]
    }),
    // Tag filter options for reports: tags of the given branches, same names listed once
    getReportTags: builder.query<
      BranchTag[],
      { organizationId: string; branchIds?: string[] }
    >({
      query: ({ organizationId, branchIds = [] }) => ({
        url: `${END_POINTS.MEMBER_TAG.GET_REPORT_TAGS(organizationId)}${
          branchIds.length
            ? buildQueryString({ branch_ids: branchIds.join(',') })
            : ''
        }`,
        method: 'GET'
      }),
      transformResponse: (response: BranchTag[] | GetMemberTagsResponse) =>
        Array.isArray(response) ? response : response.tags,
      providesTags: [ApiTags.BRANCH_TAGS]
    }),
    createBranchTag: builder.mutation<
      HTTPResponse<BranchTag>,
      CreateMemberTagRequest
    >({
      query: (req) => ({
        url: END_POINTS.MEMBER_TAG.CREATE_TAG(req.params),
        method: 'POST',
        body: req.body
      }),
      invalidatesTags: [ApiTags.BRANCH_TAGS]
    }),
    updateBranchTag: builder.mutation<
      HTTPResponse<BranchTag>,
      UpdateMemberTagRequest
    >({
      query: (req) => ({
        url: END_POINTS.MEMBER_TAG.UPDATE_TAG(req.params),
        method: 'PATCH',
        body: req.body
      }),
      invalidatesTags: [ApiTags.BRANCH_TAGS]
    })
  })
});

export const {
  useGetBranchTagsQuery,
  useGetReportTagsQuery,
  useCreateBranchTagMutation,
  useUpdateBranchTagMutation
} = extendedBaseQuery;
